var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { MultipleAutocompleteTemplate } from '@ReactComponents/Autocomplete/MultipleAutocompleteTemplate';
import { toTitleCase } from '@Shared/helpers/textFormatter';
const STATES = ['active', 'suspended', 'canceled', 'unactivated'];
const NAMES = {
    active: 'Active',
    suspended: 'Suspended',
    canceled: 'Canceled',
    unactivated: 'Not Activated'
};
export const CardStateAutocomplete = (_a) => {
    var { initialItems = ['active', 'unactivated'] } = _a, otherProps = __rest(_a, ["initialItems"]);
    function getFilterName(filterValue) {
        return NAMES[filterValue] || toTitleCase(filterValue);
    }
    const items = React.useMemo(() => STATES.map((stateValue) => ({ item: { id: stateValue, name: getFilterName(stateValue) } })), []);
    return _jsx(MultipleAutocompleteTemplate, Object.assign({ items: items, initialItems: initialItems }, otherProps));
};
